import React, { useState } from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import { Accordion, IItem as IIccordionItem } from '~common/accordion'

const ChatsFAQ = () => {
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const questions: IIccordionItem[] = [
    {
      title: 'Что такое омниканальность?',
      text: <span>Омниканальность — это объединение всех каналов связи с клиентов в одну систему. Телефон, мессенджеры, чат на сайте, социальные сети - все способы коммуникации связаны воедино, а менеджер может общаться с клиентом прямо из CRM-системы так, как удобно клиенту. Омниканальность — тренд в бизнесе и маркетинге. Про тренды в маркетинге у нас есть статья, ознакомиться можно по <a target="_blank" href='https://blog.onlinepbx.ru/2024/05/18/trend-marketing/'>ссылке</a>.</span>
    },
    {
      title: 'Дадут ли чаты реальную выгоду, измеряемую в деньгах?',
      text: 'Конечно. Омниканальность позволяет увеличить количество входящих обращений и конверсию за счет персонализированной коммуникации. Это неизбежно ведет к росту прибыли в бизнесе. По разным данным и бенчмаркам с рынка омниканальный подход приносит рост прибыли в бизнесе порядка 45%.'
    },
    {
      title: 'Есть ли интеграция с CRM?',
      text: 'Да, сервис интегрируется с Bitrix24 и amoCRM. Ваши сотрудники смогут вести и голосовую и текстовую коммуникацию с клиентами прямо внутри карточки сделки.'
    }
  ]

  return (
    <Screen
      title={<span><StyledScreen.GreenText>Ответы</StyledScreen.GreenText> на часто задаваемые вопросы</span>}
      className='chats-faq'
      bottomLine
    >
      <div className='chats-faq__container'>
        <Accordion
          data={questions}
          initialElemIndex={0}
          onChange={(index: number) => {
            setActiveItemIndex(index)
          }}
        />
      </div>
    </Screen>
  )
}

export default ChatsFAQ